import type { EnumType } from "../enums/EnumType";

const DateFormat = {
  /**
   * @example 14
   */
  DayOfMonth: "d",
  /**
   * @example Januari
   **/
  FullMonth: "MMMM",
  /**
   * @example 2023
   **/
  FullYear: "y",
  /**
   * @example 29 apr. 2022
   */
  LongLocalizedDate: "d LLL y",
  /**
   * @example 10:00
   */
  LongLocalizedTime: "T",
  /**
   * @example 2023-01-01
   **/
  Date: "yyyy-MM-dd",
  /**
   * @example 29 apr. 2022 kl. 10:00
   */
  LongLocalizedDateTime: "d LLL y 'kl.' T",
  /**
   * @example mån
   */
  ShortDayName: "EEE",
  /**
   * @example M
   **/
  SingleLetterDay: "EEEEE",
  /**
   * @example 2022-08
   **/
  YearAndMonth: "yyyy-MM",
  /**
   * @example november 23
   **/
  MonthAndYear: "MMMM yy",

  /**
   * @example november 2023
   **/
  MonthAndFullYear: "MMMM y",
  /**
   * @example 3 jan.
   **/
  DayAndMonth: "d LLL",
  /**
   * @example jan.
   **/
  ShortMonth: "LLL",
  Date46Elks: "y-LL-dd'T'TT.S",
} as const;

type DateFormat = EnumType<typeof DateFormat>;

export default DateFormat;
